import CalloutHelpers from '../helpers/calloutHelpers'

const DEFAULT_TYPE = 'application/octet-stream'

export const openFileInWebMobile = async (attachmentId: string, fileName: string) =>{
        try{
            let response = await CalloutHelpers.getFileDirectly(attachmentId)
            // axios types this header as AxiosHeaderValue | undefined, which admits
            // null and string[]; Blob only accepts a string type.
            let contentType = response.headers['content-type']
            let mimetype = typeof contentType === 'string' ? contentType : undefined
            let blob = new Blob([response.data], {type: mimetype})
            let fileSource = window.URL.createObjectURL(blob)

            const anchor = document.createElement('a');
            anchor.href = fileSource
            anchor.download = fileName
            document.body.appendChild(anchor)
            anchor.click()
            document.body.removeChild(anchor)
        }catch(err){
            //should prompt the user that this has happened
        }
}

export const openFileInWeb =  async (attachmentId:string, mimetype: string) =>{
    try{
        let response =  await CalloutHelpers.getFileLink(attachmentId)
        let anchor = document.createElement('a')
        anchor.href = response.data.url
        anchor.target = '_blank'
        if(mimetype === DEFAULT_TYPE){
            anchor.download = ''
            anchor.target = ''
        }
        document.body.appendChild(anchor)
        anchor.click()
        document.body.removeChild(anchor)
    }catch(err){
      //noop
    }
}

export const openSnapshotInWeb = async (accountId, snapshotLengthInDays) => {
  try {
    const response = await CalloutHelpers.getPdfSnapshotLink(accountId, snapshotLengthInDays);
    const anchor = document.createElement('a');
    anchor.href = response.data.url;
    anchor.target = '_blank';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  } catch (err) {
    //noop
  }
}
